import utils from '../../utils/tag-name';

const TAG_NAME = utils.constructTagName('cardbutton');

export { TAG_NAME };
